import { useSelector } from 'react-redux';
import { Device } from '@beef/smart-kit';
import React, { useCallback } from 'react';

import { getIsItemInBasket } from 'store/common/basket/selectors';
import { deviceCardPurchaseButtonDataHelper } from 'utils/deviceCardPurchaseButtonDataHelpers';

type RecommendationDeviceProps = {
  device: any;
  onAddToBasket: (id: number) => void;
};
const RecommendationDevice = ({ device, onAddToBasket }: RecommendationDeviceProps) => {
  const isInBasket = useSelector((state) => getIsItemInBasket(state, device?.id?.toString()));
  const purchaseButtonData = deviceCardPurchaseButtonDataHelper({
    isInBasket,
  });

  const onOpenModal = useCallback(() => {
    window.location.href = device?.link;
  }, []);

  return (
    <Device
      device={device}
      purchaseData={{ ...purchaseButtonData, onClick: onAddToBasket }}
      onOpenModal={onOpenModal}
    />
  );
};

export default RecommendationDevice;
